import { apiClient } from './apiClient';

export type CatalogType = 'prompts' | 'schemas' | 'ocr-configs' | 'llm-configs' | 'llm-models';

export interface CatalogUsageItem {
  client_id: string;
  client_name: string;
  client_slug: string;
  domain_code: string;
}

export interface CatalogUsagesResponse {
  count: number;
  usages: CatalogUsageItem[];
}

export const catalogUsagesService = {
  async getUsages(type: CatalogType, objectId: string): Promise<CatalogUsagesResponse> {
    // PROD1.5.6 #557 — llm-models utilise une route dédiée sous /admin/, jointure indirecte.
    const path =
      type === 'llm-models'
        ? `/admin/llm-models/${objectId}/usages`
        : `/catalog/${type}/${objectId}/usages`;
    const res = await apiClient.get<CatalogUsagesResponse>(path);
    return res.data;
  },
};
